import BaseModel from './BaseModel';

class FleetOwner extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.setApiDetailsData(data)
  }

  setApiDetailsData = (data) => {
    this.id = data.nomenclature_id;
    this.name = data.name;
    this.mobile_number = data.mobile_number;
    this.wallet_balance = data.wallet_balance;
    this.status = data.status;
    this.approved_at = data.activated_at;
    this.manager = data.manager;
    this.vehicle_count = data.vehicles_count;
    this.customers_count =  data.customers_count;
    if(data.firm) {
      this.firm_name = data.firm.name
    }
    if(data.address) {
      this.address = `${data.address.address || ""} ${data.address.city || ""} ${data.address.state}`
      this.pincode = data.address.pincode_code
    }
  }
}

export default FleetOwner;


